import styles from '../styles/Sidebar.module.sass';

import { FC, SyntheticEvent, useState } from 'react';
import { Nav, Navbar } from 'rsuite';
import { Link } from "react-router-dom";
import { IRoute } from 'utils/routes';

export interface Nav2Props {
  routes: IRoute[];
  activeKey: string;
  onSelect: (eventKey: string, event?: SyntheticEvent<Element, Event>) => void;
}

const NavMenu2: FC<Nav2Props> = ({ routes, ...props }) => {
  const [expanded, setExpanded] = useState(false);
  const [image, setImage] = useState("/media/logo-navbar.svg");

  const renderNav2 = routes.map(route => (
    <Nav.Item
      className={props.activeKey == route.path ? styles.itemActive : styles.item}
      eventKey={route.path}      
      as={Link}
      to={route.path}
      key={route.id}
      style={{width: '100%'}}
    >
      { route.label }
    </Nav.Item>
  ));

  return (
    <Navbar style={{height: '100%'}}>
      <Navbar.Brand style={{
        padding: '25px 80px 50px 80px',
        textAlign: 'center'}}>
        <Link to="/" onClick={()=>props.onSelect("/")}>
          <img src={image} alt="Logo AMSA" />
        </Link>        
      </Navbar.Brand>    
      <Nav style={{width: '100%'}}>
        { renderNav2 }
      </Nav>
    </Navbar>
  );
};

export default NavMenu2;